import IconDoc from './component.jsx'
export default IconDoc
